import Button from '@Components/Button'
import { theme } from '@Styles/config'
import { facebookIcon, linkedInIcon, oneLoginIcon, googleIcon, azureIcon } from './SSOIcons'
import { darken, getLuminance, lighten } from 'polished'
import React from 'react'
import styled from 'styled-components'

export interface Provider {
  provider: {
    provider_id: number
    provider_type: string
    bg_color: string
    url: string
    title: string
    icon_url?: string
    method?: any
  }
}

export interface SSOButtonProps {
  href?: string
  color: string
  onClick?: () => any
  theme: {
    colors: {
      gutterLarge: string
    }
  }
}

export const SSORedirect = (url: string): void => {
  if (window) {
    window.location.href = url
  }
}

export const getSSOIcon = (provider_type: string): JSX.Element | null => {
  switch (provider_type) {
    case 'facebook':
      return facebookIcon()
    case 'google':
      return googleIcon()
    case 'linkedin':
      return linkedInIcon()
    case 'azure':
      return azureIcon()
    case 'onelogin':
      return oneLoginIcon()
    default:
      return null
  }
}

const capitalizeFirstLetter = (inputString: string) => {
  return inputString.charAt(0).toUpperCase() + inputString.slice(1)
}

const SSOButtons = (provider: Provider): JSX.Element => {
  const { title, bg_color, url, provider_type } = provider.provider
  return (
    <SSOButton
      href={url}
      color={bg_color || theme.colors.primaryAccentColor}
      onClick={() => SSORedirect(url)}
    >
      <Icon>{getSSOIcon(provider_type)}</Icon>
      <Title>{title || `Sign in with ${capitalizeFirstLetter(provider_type)}`}</Title>
    </SSOButton>
  )
}

export default SSOButtons

const Icon = styled.div`
  display: flex;
  padding-right: ${({ theme }) => theme.sizes.gutterSmall};
  justify-content: center;
  align-items: center;
`

const Title = styled.div`
  display: flex;
`

const SSOButton = styled(Button)<SSOButtonProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 40px;
  line-height: 40px;
  padding: 0 ${({ theme }) => theme.colors.gutterLarge};
  margin: 15px 0 !important;
  letter-spacing: 0.2px;
  border-radius: 2px;
  background-color: ${({ color }) => color};
  color: ${({ color }) => (getLuminance(color) >= 0.5 ? '#747474' : '#fff')};
  font-weight: 500;
  font-size: 13px;
  font-family: Roboto, Helvetica, Arial, sans-serif;

  &:hover,
  :focus {
    color: ${({ color }) => (getLuminance(color) >= 0.5 ? '#747474' : '#fff')};
    background-color: ${({ color }) =>
      getLuminance(color) >= 0.5 ? darken(0.05, color) : lighten(0.05, color)};
  }
`
